module.exports = __webpack_public_path__ + "img/card_icon_four.206431bc.png";